"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableRows = void 0;
const react_1 = __importStar(require("react"));
const date_fns_1 = require("date-fns");
const components_1 = require("../components");
const table_1 = require("../components/table");
const constants_1 = require("../../constants");
const icons_1 = require("../../icons");
const localization_1 = require("../../localization");
const state_1 = require("../../store/state");
const useTableRows = ({ activeColumns, getAdditionalRows, getColumnFilterValue }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const getBaseRows = (0, react_1.useCallback)((product, options) => {
        var _a;
        const { id, proprietaryId, images, title, description, url, variantGroupId, createdAt, updatedAt, active, attributes, } = product;
        const curatedAttributesFilter = getColumnFilterValue === null || getColumnFilterValue === void 0 ? void 0 : getColumnFilterValue(constants_1.ColumnId.CuratedAttributes);
        const filteredAttributes = curatedAttributesFilter
            ? attributes.filter(({ id }) => curatedAttributesFilter.includes(id))
            : attributes;
        const standardFieldsMap = {
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID]: id,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID]: proprietaryId,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.NAME]: title,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION]: description,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP]: variantGroupId,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE]: (0, date_fns_1.format)(createdAt, constants_1.DATE_TIME_FORMAT_DASH),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED]: (0, date_fns_1.format)(updatedAt, constants_1.DATE_TIME_FORMAT_DASH),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.URL]: url,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS]: (t({ key: active ? 'ACTIVE' : 'INACTIVE' })).toLowerCase(),
        };
        const { isExpanded } = options !== null && options !== void 0 ? options : {};
        const imageSrc = (_a = images[0]) === null || _a === void 0 ? void 0 : _a.sourceUrl;
        return {
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID]: react_1.default.createElement(table_1.TextCell, { key: "id" }, id),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID]: react_1.default.createElement(table_1.TextCell, { key: "proprietaryId" }, proprietaryId),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE]: react_1.default.createElement(table_1.ImageCell, { key: "image", expanded: isExpanded, src: imageSrc, alt: title }),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.NAME]: react_1.default.createElement(table_1.LinkCell, { key: "name", multiline: true, tooltipTitle: title, href: url, target: "_blank", textSize: "small", expanded: isExpanded }, title),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION]: react_1.default.createElement(table_1.TextCell, { key: "description", multiline: true, tooltipTitle: description, textSize: "small", expanded: isExpanded }, description),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP]: react_1.default.createElement(table_1.TextCell, { key: "productGroup" }, variantGroupId),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE]: react_1.default.createElement(table_1.TextCell, { key: "createdDate" }, standardFieldsMap[state_1.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE]),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED]: react_1.default.createElement(table_1.TextCell, { key: "updatedDate" }, standardFieldsMap[state_1.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED]),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.URL]: react_1.default.createElement(table_1.LinkCell, { key: "url", href: url }, url && react_1.default.createElement(icons_1.LinkIcon, null)),
            // descoped for MVP
            // [COLUMNS.PRICE]: <StyledCell align="left">{null}</StyledCell>,
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS]: react_1.default.createElement(table_1.TextCell, { key: "activeStatus" }, standardFieldsMap[state_1.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS]),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.CURATED_ATTRIBUTES]: (react_1.default.createElement(table_1.ConsolidatedListCell, { key: "attributes", expanded: isExpanded, valueNumber: filteredAttributes.length }, react_1.default.createElement(components_1.Attributes, { attributes: filteredAttributes }))),
            [state_1.PRODUCT_EDITOR_TABLE_COLUMNS.STANDARD_FIELDS]: (react_1.default.createElement(table_1.ConsolidatedListCell, { key: "standardFields", expanded: isExpanded, valueNumber: Object.keys(standardFieldsMap).length }, react_1.default.createElement(components_1.ConsolidatedList, { data: standardFieldsMap }))),
        };
    }, [getColumnFilterValue, t]);
    const getTableRowsTemplate = (0, react_1.useCallback)((product, options) => (Object.assign(Object.assign({}, getBaseRows(product, options)), getAdditionalRows === null || getAdditionalRows === void 0 ? void 0 : getAdditionalRows(product, options))), [getAdditionalRows, getBaseRows]);
    return (0, react_1.useCallback)((product, options) => (activeColumns.map((item, index) => { var _a; return (_a = getTableRowsTemplate(product, options)[item]) !== null && _a !== void 0 ? _a : react_1.default.createElement(table_1.TextCell, { key: index, align: "left" }); })), [activeColumns, getTableRowsTemplate]);
};
exports.useTableRows = useTableRows;
